import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
   {
      key: 'id',
      field: FIELDS.ID,
      title: 'Report No',
      label: 'Report No',
      sortable: true,
      hidden: false,
      width: 75,
   },{
      key: 'dateInspected',
      field: FIELDS.DATE_INSPECTED,
      title: 'Date Insp',
      label: 'Date Insp',
      cell: 'formatDate',
      sortable: true,
      hidden: false,
      width: 150,
   },{
     key: 'inspectionReportTypeName',
     field: FIELDS.INSPECTION_REPORT_TYPE_NAME,
     title: 'Type',
     label: 'Type',
     sortable: true,
     hidden: false,
     width: 150,
   },{
     key: 'vendorName',
     field: FIELDS.VENDOR_NAME,
     title: 'Vendor',
     label: 'Vendor',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorContactFullName',
     field: FIELDS.VENDOR_CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'soDate',
     field: FIELDS.SODATE,
     title: 'SO Date',
     label: 'SO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'customerName',
     field: FIELDS.CUSTOMER_NAME,
     title: 'Customer',
     label: 'Customer',
     sortable: true,
     hidden: false,
     width: 150,
  },{
      key: 'partNumber',
      field: FIELDS.PART_NUMBER,
      title: 'Part Number',
      label: 'Part Number',
      sortable: true,
      hidden: false,
      width: 150,
   },{
      key: 'mfgName',
      field: FIELDS.MFG_NAME,
      title: 'Mfr',
      label: 'Mfr',
      sortable: true,
      hidden: false,
      width: 150,
   },{
     key: 'salesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
      key: 'inspectedByUserFullName',
      field: FIELDS.INSPECTED_BY_USER_FULL_NAME,
      title: 'Inspected By',
      label: 'Inspected By',
      sortable: true,
      hidden: false,
      width: 150,
   },{
     key: 'quantitySold',
     field: FIELDS.QUANTITY_SOLD,
     title: 'Qty Sold',
     label: 'Qty Sold',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'internalPn',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'sku',
     field: FIELDS.SKU,
     title: 'SKU',
     label: 'SKU',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Package',
     label: 'Package',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'ordered',
     field: FIELDS.ORDERED,
     title: 'Qty Ordered',
     label: 'Qty Ordered',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'conditionName',
     field: FIELDS.CONDITION_NAME,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: true,
     width: 150,
  },{
      key: 'dateCreated',
      field: FIELDS.DATE_CREATED,
      title: 'Date Created',
      label: 'Date Created',
      cell: 'formatDate',
      sortable: true,
      hidden: true,
      width: 150,
   },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'DateModified',
     label: 'DateModified',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'trackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: 'TrackingNumber',
     label: 'TrackingNumber',
     sortable: true,
     hidden: true,
     width: 150,
  }, {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
